import React from 'react';

const TeamSample = ({ contactLink }) => {


    return (
        <div>
            {/* Display the contact link preview */}
            <h3>Preview</h3>
            <div>
                <h4>{contactLink.details?.linkTitle}</h4>
                <a href={
                    contactLink.details?.linkUrl



                } target="_blank" rel="noopener noreferrer">
                    {contactLink.details?.linkUrl}
                </a>
                <p>Type: {contactLink.type}</p>
            </div>
        </div>
    );
};

export default TeamSample;
